import { Link } from "react-router-dom";

const stats = [
  { value: "12", label: "影视作品" },
  { value: "12", label: "签约演员" },
  { value: "10+", label: "行业动态" },
  { value: "5", label: "内容类型" },
];

export default function BrandIntro() {
  return (
    <section className="w-full bg-primary-950">
      <div className="mx-auto grid w-full max-w-page grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2 lg:gap-16">
        <div>
          <div className="mb-3 flex items-center gap-2">
            <span className="h-1 w-6 rounded-full bg-accent-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">About Studio</span>
          </div>
          <h2 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
            用光影讲好每一个故事
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-background-300 md:text-base">
            朝桐光是一家专注影视内容创作与出品的品牌，业务覆盖电影、电视剧的策划、制作与发行。我们相信，好的作品经得起时间，也值得被认真对待。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-background-400 md:text-base">
            从悬疑、科幻到历史、家庭，朝桐光持续在多元题材中探索，用真诚的创作回馈每一位观众，也让更多优秀的创作者被看见。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg border border-primary-900 bg-primary-900/40 px-3 py-4 text-center">
                <div className="font-heading text-2xl font-black text-accent-400">{s.value}</div>
                <div className="mt-1 text-xs text-background-300">{s.label}</div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              了解品牌故事
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/10"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="relative w-full">
          <div className="w-full overflow-hidden rounded-lg" style={{ aspectRatio: "4 / 3" }}>
            <img
              src="https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20photo%20of%20a%20film%20set%20with%20a%20camera%20rig%20and%20warm%20amber%20key%20lights%20against%20deep%20navy%20shadows%2C%20atmospheric%20professional%20production%20still%2C%20high%20detail&width=1200&height=900&seq=brand-intro-01&orientation=landscape"
              alt="朝桐光影视制作幕后"
              title="朝桐光影视制作幕后"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 -left-4 hidden rounded-lg border border-primary-900 bg-primary-900 px-5 py-4 sm:block">
            <div className="font-heading text-lg font-black text-background-50">专注内容</div>
            <div className="text-xs text-background-300">Content First · 长期主义</div>
          </div>
        </div>
      </div>
    </section>
  );
}